module.exports = "<p>\r\n  historico-atendimento works!\r\n</p>\r\n"